import { createRouter, createWebHistory } from 'vue-router'
import store from "@/store";
import {message} from "ant-design-vue";

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/index/the-whole.vue'),
        meta: {
            loginRequire: true
        },
        children: [
            {
                path: 'devops/',
                component: () => import('../views/devops/main-index.vue'),
                meta: {
                    loginRequire: true
                },
                redirect: '/devops/mg-account',
                children: [
                    {
                        path: 'mg-account',
                        component: () => import('../views/devops/page/mg-account-page.vue')
                    },{
                        path: 'mg-role',
                        component: () => import('../views/devops/page/mg-role-page.vue')
                    },{
                        path: 'mg-api',
                        component: () => import('../views/devops/page/mg-api-page.vue')
                    },{
                        path: 'mg-function',
                        component: () => import('../views/devops/page/mg-function-page.vue')
                    },{
                        path: 'mb-account',
                        component: () => import('../views/devops/page/mb-account-page.vue')
                    },{
                        path: 'mb-order',
                        component: () => import('../views/devops/page/mb-order-page.vue')
                    },{
                        path: 'mb-coin',
                        component: () => import('../views/devops/page/mb-coin-page.vue')
                    },{
                        path: 'mb-api',
                        component: () => import('../views/devops/page/mb-api-page.vue')
                    },{
                        path: 'channel-list',
                        component: () => import('../views/devops/page/channel-list-page.vue')
                    },{
                        path: 'cus-list',
                        component: () => import('../views/devops/page/cus-list-page.vue')
                    },{
                        path: 'ana-compass-list',
                        component: () => import('../views/devops/page/ana-compass-list-page.vue')
                    },{
                        path: 'ana-trend-list',
                        component: () => import('../views/devops/page/ana-trend-list-page.vue')
                    },{
                        path: 'compass-role-list',
                        component: () => import('../views/devops/page/compass-role-list-page.vue')
                    },{
                        path: 'trend-role-list',
                        component: () => import('../views/devops/page/trend-role-list-page.vue')
                    },{
                        path: 'data-tp',
                        component: () => import('../views/devops/page/data-tp-page.vue')
                    },{
                        path: 'metadata-list',
                        component: () => import('../views/devops/page/metadata-list-page.vue')
                    },{
                        path: 'log-list',
                        component: () => import('../views/devops/page/log-list-page.vue')
                    },{
                        path: 'pipeline-list',
                        component: () => import('../views/devops/page/pipeline-list-page.vue')
                    }
                ]
            },
            {
                path: 'func/',
                component: () => import('../views/func/main-index.vue'),
                meta: {
                    loginRequire: true
                },
                redirect: '/func/clue-list',
                children: [
                    {
                        path: 'clue-list',
                        component: () => import('../views/func/page/clue-list-page.vue')
                    },{
                        path: 'clue-shopping-list',
                        component: () => import('../views/func/page/clue-shopping-page.vue')
                    },{
                        path: 'clue-analysis',
                        component: () => import('../views/func/page/clue-analysis-page.vue')
                    },{
                        path: 'base-cus-list',
                        component: () => import('../views/func/page/base-cus-page.vue')
                    },{
                        path: 'vip-list',
                        component: () => import('../views/func/page/vip-list-page.vue')
                    },{
                        path: 'sh-yido-list',
                        component: () => import('../views/func/page/sh-yido-list-page.vue')
                    },{
                        path: 'files-download',
                        component: () => import('../views/func/page/files-download-page.vue')
                    },{
                        path: 'clue-track',
                        component: () => import('../views/func/page/clue-track-page.vue')
                    }
                ]
            },
            {
                path: 'shopping/',
                component: () => import('../views/shopping/main-index.vue'),
                meta: {
                    loginRequire: true
                },
                redirect: '/shopping/gds-order',
                children: [
                    {
                        path: 'gds-order',
                        component: () => import('../views/shopping/page/gds-order-page.vue')
                    },
                    {
                        path: 'rights-used',
                        component: () => import('../views/shopping/page/rights-used-page.vue')
                    },
                    {
                        path: 'goods-sort',
                        component: () => import('../views/shopping/page/goods-sort-page.vue')
                    },
                    {
                        path: 'brand-list',
                        component: () => import('../views/shopping/page/brand-list-page.vue')
                    },
                    {
                        path: 'goods-list',
                        component: () => import('../views/shopping/page/goods-list-page.vue')
                    },{
                        path: 'rights-list',
                        component: () => import('../views/shopping/page/rights-list-page.vue')
                    },
                    {
                        path: 'user-rights',
                        component: () => import('../views/shopping/page/user-rights-page.vue')
                    },{
                        path: 'user-list',
                        component: () => import('../views/shopping/page/user-list-page.vue')
                    },{
                        path: 'cart-list',
                        component: () => import('../views/shopping/page/cart-list-page.vue')
                    },{
                        path: 'shop-activity',
                        component: () => import('../views/shopping/page/shop-activity-page.vue')
                    },{
                        path: 'logistics-config',
                        component: () => import('../views/shopping/page/logistics-config-page.vue')
                    },{
                        path: 'ship-account',
                        component: () => import('../views/shopping/page/ship-account-page.vue')
                    }
                ]
            },
            {
                path: 'web-main',
                component: () => import('../views/index/web-main.vue')
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login-page.vue')
    },{
        path: '/logout',
        name: 'logout',
        component: () => import('../views/logout-page.vue')
    },{
        path: '',
        redirect: '/web-main'
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// 页面路由登录拦截，未登录的静态页面也不可访问
router.beforeEach((to, from, next) => {
    // 要不要对meta.loginRequire属性做监控拦截
    if (to.matched.some(function (item) {
        console.log(item, "是否需要登录校验：", item.meta.loginRequire || false);
        return item.meta.loginRequire
    })) {
        const _user = store.state.userInfo;
        console.log("页面登录校验开始：", _user);
        if (!_user.token) {
            console.log("用户未登录或登录超时！");
            message.error("登录超时或没有权限!")
            next('/login');
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router
